// ###### START UM ############## 

import { isCasePI, isDateInThePast, isStateOfPip } from "./script"
import { retrieveTransportaionsData, selfPaySettings } from "./systemData"

// If Verified & UM are present, then the following change to red  - Claim # - UM Amount - UM Type
export function umFiledsBorderRed(data, specificFiled) {
    if (data) {
        if (data.um_verified &&  data.has_um == 1 && !data[specificFiled]) {
            return true
        }
    }

    return false
}

// Verified can only be checked if Policy number present + UM Type is selected. 
export function disableVerifySelection(data, tab, prefix) {
    if (data) {
        if (tab == 'um') {
            let errors = []

            if (data.um_type == null) {
                errors.push('Please select the UM Type first.')
            }
            if (!data.um_policy_limit_patient) {
                errors.push('UM Limit Patient is required')
            }   
            if (!data.um_policy_limit_accident) {
                errors.push('UM Limit Accident is required')
            }

            if (errors.length) {
                return {
                    status: true,
                    message: errors
                }
            }

        }

        if (tab == 'medpay') {
            if (prefix == 'pip') {
                let errors = []
                if (!data.pip_claim_number) {
                    errors.push('PIP Claim number is required')
                }
                if (errors.length) {
                    return {
                        status: true,
                        message: errors
                    }
                }
            }
        }

        if (tab == 'liability') {
            let errors = []       
            if (data.liability_status == null) {
                errors.push('Please select a Liability Status first.')
            }
       
            if (errors.length) { 
                return {
                    status: true,
                    message: errors
                }
            }
        }

        if (tab == 'major_meds') {

        }
        
    }

    return {
        status: false,
    }
}

// ###### END UM ############## 


// ############ START Medpay #################
export function isPipEnabledForEntry(caseState, item) {
    if (!item) {
        return false
    }

    return isStateOfPip(item.insurance_state)
}

export function hasPipOrMP(data, state) {
    if(data) {
        return (isPipEnabledForEntry(state, data) && data.has_pip != 0) || data.has_mp == 1
    }

    return false
}

export function posibleNewPrimaryMP(item, currentItem) {
    // it should not be marked as PIP/MP Exhausted already
    // it should have PIP/MP (available - checkbox)
    // it should be Verified (could be ignored if none are verified).
    if (item) {
        if (item.id !== currentItem.id) { // ignore the current item
            if (item.active) { // it sholud be active!!!!!
                if ((item.has_pip == 1 || item.has_mp == 1) && // has pip or mp
                (!item.pip_exausted || !item.mp_exausted)) { // it is not mark as exhausted at least in one place
    
                    if ((item.has_pip == 1 && !item.pip_exausted) || (item.has_mp == 1 && !item.mp_exausted)) {
                        return true
                    }
                    
                }
            }
        }
        
    } 

    return false
}

// ###### END Medpay ############## 

// ################## SelfPay and CHUSA ################## 

// There will be a message showing up for CHUSA in case there is an active Major Med insurnace (it has to be active and valid)
export function majorMedExistsAndIsValid(activeCase) {

    function isValid(item) {
        if (item.active && item.verified && !isDateInThePast(item.end_date) && !item.no_coverage && !item.no_insurance) {
            if (isCasePI(activeCase)) {
                if (activeCase?.case?.hiof_selected == 1) {
                    return true
                }
            } else {
                return true
            }  
        }

        return false
    }

    if (activeCase && activeCase.major_meds) {
        let activeMajorMed = activeCase.major_meds.some(item => isValid(item))
        if (activeMajorMed) {
            return true
        }
    }

    return false
}

export function totalBalanceExceedsTheSettings(balance) {
    if (balance && selfPaySettings()) {
        if (selfPaySettings().total_balance < balance) {
            return true
        }
    }

    return false
}

export function numberOfPaymentsExceedsTheSettings(no_payments) {
    if (no_payments && selfPaySettings()) {
        if (selfPaySettings().no_payments < no_payments) {
            return true
        }
    }

    return false
}



// ################ transportations ##################### 

export function dennyFurtherTrips(case_transportation) {
    if (case_transportation) {
        if (case_transportation.deny_further_trips) {
            return {
                is_denied: true,
                message: ['New trips are disabled']
            }
        }

        if (!case_transportation.has_contract_signed) { //user cannot create more rides if the contract is not signed
            if (case_transportation.rides && case_transportation.rides.length >= retrieveTransportaionsData()?.free_ride_without_contract_signed) {
                return {
                    is_denied: true,
                    message: ['Free rides without a contract signed are exhausted.']
                }
            }
        }

        if (case_transportation.funds_remaining < retrieveTransportaionsData()?.minimum_charge) {
            return {
                is_denied: true,
                message: [`Insufficient funds, less than ${retrieveTransportaionsData()?.minimum_charge} available.`]
            }
        }
    }

    return {
        is_denied: false,
        message: null
    }
}

// export function calculateFinalTripCharge(miles, pricepermile, rideType) {
//     let transportationSystemData = retrieveTransportaionsData()

//     let lyft_ride_cost = rideType ? rideType.estimated_cost_cents_max/100 : null
//     // let tripCharge = miles * pricepermile

//     let total  = lyft_ride_cost * pricepermile

//     if (total > transportationSystemData.minimum_charge) {
//         return total.toFixed(2)
//     } else {
//         return transportationSystemData.minimum_charge
//     }
//     // if (lyft_ride_cost > tripCharge) {
//     //     if (lyft_ride_cost > transportationSystemData.minimum_charge) {
//     //         return lyft_ride_cost
//     //     } else {
//     //         if (tripCharge > transportationSystemData.minimum_charge) {

                
//     //             return tripCharge
//     //         }

//     //         return 25
//     //     }        
//     // } 

//     // if (tripCharge > transportationSystemData.minimum_charge) {
//     //     return tripCharge
//     // }

//     // return 25
// }

export function calculateFinalTripCharge(pricepermile, rideType) {
    let transportationSystemData = retrieveTransportaionsData()

    let lyft_ride_cost = rideType ? rideType.estimated_cost_cents_max/100 : null

    let total  = lyft_ride_cost * pricepermile

    if (total > transportationSystemData.minimum_charge) {
        return total.toFixed(2)
    } else {
        return transportationSystemData.minimum_charge
    }
}